import { Injectable } from '@angular/core';

import { NotificationsService } from '../../../services/notifications/notifications.service';
import { DataApiService } from '../../../services/data-api/data-api.service';
import { DownloadsService } from '../../../services/downloads/downloads.service';

export interface GroupedDownloadRequest {
  origins: string[];
  aliases?: Record<string, string>;
  filename: string;
  year: string;
}

@Injectable({ providedIn: 'root' })
export class GroupedDownloadsService {
  constructor(
    private notificationsService: NotificationsService,
    private dataApiService: DataApiService,
    private downloadsService: DownloadsService,
  ) {}

  buildRequest(
    downloads: { origin: string; alias?: string }[],
    year: string,
  ): GroupedDownloadRequest {
    const aliases: Record<string, string> = {};
    const uniqueOrigins = Array.from(new Set((downloads || [])
      .map((download) => download.origin)
      .filter((origin) => !!origin)));

    (downloads || []).forEach((download) => {
      if (!download.origin || !download.alias || aliases[download.origin]) {
        return;
      }

      aliases[download.origin] = download.alias;
    });

    return {
      origins: uniqueOrigins,
      aliases,
      filename: `bdr_descarga_agrupada_${this.getTimestamp()}`,
      year,
    };
  }

  requestDownload(request: GroupedDownloadRequest): void {
    if (!request.origins.length) {
      this.notificationsService.add({
        type: 'warning',
        message: 'No hay objetos seleccionados para la descarga agrupada.',
        fixed: false,
        popup: true,
      });
      return;
    }

    if (!request.year) {
      this.notificationsService.add({
        type: 'warning',
        message: 'No se ha podido determinar el año retributivo actual.',
        fixed: false,
        popup: true,
      });
      return;
    }

    this.downloadsService.downloadNotificationTimer();
    this.dataApiService.downloadGrouped(request.origins, request.filename, request.year, request.aliases).subscribe(
      (response) => {
        const jobId = response.async_job_id;
        this.downloadsService.addDownload({
          id: jobId,
          fileName: request.filename,
          url: '#',
          status: 'RUNNING',
        });
        this.downloadsService.pollAsyncJob(jobId).subscribe((pollResponse) => {
          this.downloadsService.processDownloadResponse(pollResponse);
        });
      },
      () => {
        this.notificationsService.add({
          type: 'error',
          message: 'Ha habido un error al iniciar la descarga agrupada.',
          fixed: false,
          popup: true,
        });
      },
    );
  }

  private getTimestamp(): string {
    const timestamp = new Date();
    const year = timestamp.getFullYear();
    let month = (timestamp.getMonth() + 1).toString();
    let day = timestamp.getDate().toString();

    month = month.length < 2 ? '0' + month : month;
    day = day.length < 2 ? '0' + day : day;

    return `${year}${month}${day}`;
  }
}
